export default __webpack_public_path__ + "static/media/twitter.145c92c1.svg";